"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValidators = exports.v20240101 = exports.v20230901 = exports.v20221101 = exports.v20220901 = exports.compatible = void 0;
var superstruct = require("superstruct");
var superstruct_1 = require("superstruct");
var _validateNTACorporateInfoResolverResponse_v20240101 = function (payload) { return validate_NTACorporateInfoResolverResponse_v20240101(payload); };
var _validateNTACorporateInfoSearcherResponse_v20240101 = function (payload) { return validate_NTACorporateInfoSearcherResponse_v20240101(payload); };
var _validateNTAQualifiedInvoiceIssuerInfoResolverResponse_v20240101 = function (payload) { return validate_NTAQualifiedInvoiceIssuerInfoResolverResponse_v20240101(payload); };
// eslint-disable-next-line @typescript-eslint/no-namespace
var compatible;
(function (compatible) {
    var refillToCompatibleNTACorporateInfo = function (data) { return ({
        published_date: data.published_date,
        sequence_number: String(data.sequence_number),
        corporate_number: data.corporate_number,
        process: String(data.process),
        correct: String(data.correct),
        update_date: data.update_date,
        change_date: data.change_date,
        name: data.name,
        name_image_id: data.name_image_id,
        kind: String(data.kind),
        prefecture_name: data.address.prefecture,
        city_name: data.address.city,
        street_number: data.address.street_number,
        town: data.address.town,
        kyoto_street: data.address.kyoto_street,
        block_lot_num: data.address.block_lot_num,
        building: data.address.building,
        floor_room: data.address.floor_room,
        address_image_id: data.address_image_id,
        jisx0402: data.address.jisx0402,
        post_code: data.address.postal_code,
        address_outside: data.address_outside,
        address_outside_image_id: data.address_outside_image_id,
        close_date: data.close_date,
        close_cause: data.close_cause == null
            ? null
            : String(data.close_cause),
        successor_corporate_number: data.successor_corporate_number,
        change_cause: data.change_cause,
        assignment_date: data.assignment_date,
        en_name: data.en_name,
        en_prefecture_name: data.address.prefecture_roman,
        en_address_line: data.en_address_line,
        en_address_outside: data.en_address_outside,
        furigana: data.furigana,
        hihyoji: String(data.hihyoji),
    }); };
    compatible.validateAddressResolverResponse = function (payload) { return validate_AddressResolverResponse_compatible(payload); };
    compatible.validateCityResolverResponse = function (payload) { return validate_CityResolverResponse_compatible(payload); };
    compatible.validateAddressSearcherResponse = function (payload) { return validate_AddressSearcherResponse_compatible(payload); };
    compatible.validateNTACorporateInfoResolverResponse = function (payload) {
        try {
            return validate_NTACorporateInfoResolverResponse_compatible(payload);
        }
        catch (e) {
            if (!(e instanceof superstruct_1.StructError)) {
                throw e;
            }
            var data = _validateNTACorporateInfoResolverResponse_v20240101(payload);
            return {
                version: data.version,
                data: refillToCompatibleNTACorporateInfo(data.data),
            };
        }
    };
    compatible.validateNTACorporateInfoSearcherResponse = function (payload) {
        try {
            return validate_NTACorporateInfoSearcherResponse_compatible(payload);
        }
        catch (e) {
            if (!(e instanceof superstruct_1.StructError)) {
                throw e;
            }
            var data = _validateNTACorporateInfoSearcherResponse_v20240101(payload);
            return {
                version: data.version,
                query: data.query,
                count: data.count,
                offset: data.offset,
                limit: data.limit,
                facets: data.facets,
                data: data.data.map(refillToCompatibleNTACorporateInfo),
            };
        }
    };
    compatible.validateNTAQualifiedInvoiceIssuerInfoResolverResponse = _validateNTAQualifiedInvoiceIssuerInfoResolverResponse_v20240101;
})(compatible = exports.compatible || (exports.compatible = {}));
// eslint-disable-next-line @typescript-eslint/no-namespace
var v20220901;
(function (v20220901) {
    v20220901.validateAddressResolverResponse = function (payload) { return validate_AddressResolverResponse_v20220901(payload); };
    v20220901.validateCityResolverResponse = function (payload) { return validate_CityResolverResponse_v20220901(payload); };
    v20220901.validateAddressSearcherResponse = function (payload) { return validate_AddressSearcherResponse_v20220901(payload); };
    v20220901.validateNTACorporateInfoResolverResponse = function (payload) { return validate_NTACorporateInfoResolverResponse_v20220901(payload); };
    v20220901.validateNTACorporateInfoSearcherResponse = function (payload) { return validate_NTACorporateInfoSearcherResponse_v20220901(payload); };
    v20220901.validateNTAQualifiedInvoiceIssuerInfoResolverResponse = _validateNTAQualifiedInvoiceIssuerInfoResolverResponse_v20240101;
})(v20220901 = exports.v20220901 || (exports.v20220901 = {}));
// eslint-disable-next-line @typescript-eslint/no-namespace
var v20221101;
(function (v20221101) {
    v20221101.validateAddressResolverResponse = function (payload) { return validate_AddressResolverResponse_v20221101(payload); };
    v20221101.validateCityResolverResponse = function (payload) { return validate_CityResolverResponse_v20221101(payload); };
    v20221101.validateAddressSearcherResponse = function (payload) { return validate_AddressSearcherResponse_v20221101(payload); };
    v20221101.validateNTACorporateInfoResolverResponse = function (payload) { return validate_NTACorporateInfoResolverResponse_v20221101(payload); };
    v20221101.validateNTACorporateInfoSearcherResponse = function (payload) { return validate_NTACorporateInfoSearcherResponse_v20221101(payload); };
    v20221101.validateNTAQualifiedInvoiceIssuerInfoResolverResponse = _validateNTAQualifiedInvoiceIssuerInfoResolverResponse_v20240101;
})(v20221101 = exports.v20221101 || (exports.v20221101 = {}));
// eslint-disable-next-line @typescript-eslint/no-namespace
var v20230901;
(function (v20230901) {
    v20230901.validateAddressResolverResponse = function (payload) { return validate_AddressResolverResponse_v20230901(payload); };
    v20230901.validateCityResolverResponse = function (payload) { return validate_CityResolverResponse_v20230901(payload); };
    v20230901.validateAddressSearcherResponse = function (payload) { return validate_AddressSearcherResponse_v20230901(payload); };
    v20230901.validateNTACorporateInfoResolverResponse = function (payload) { return validate_NTACorporateInfoResolverResponse_v20230901(payload); };
    v20230901.validateNTACorporateInfoSearcherResponse = function (payload) { return validate_NTACorporateInfoSearcherResponse_v20230901(payload); };
    v20230901.validateNTAQualifiedInvoiceIssuerInfoResolverResponse = _validateNTAQualifiedInvoiceIssuerInfoResolverResponse_v20240101;
})(v20230901 = exports.v20230901 || (exports.v20230901 = {}));
// eslint-disable-next-line @typescript-eslint/no-namespace
var v20240101;
(function (v20240101) {
    v20240101.validateAddressResolverResponse = function (payload) { return validate_AddressResolverResponse_v20240101(payload); };
    v20240101.validateCityResolverResponse = function (payload) { return validate_CityResolverResponse_v20240101(payload); };
    v20240101.validateAddressSearcherResponse = function (payload) { return validate_AddressSearcherResponse_v20240101(payload); };
    v20240101.validateNTACorporateInfoResolverResponse = _validateNTACorporateInfoResolverResponse_v20240101;
    v20240101.validateNTACorporateInfoSearcherResponse = _validateNTACorporateInfoSearcherResponse_v20240101;
    v20240101.validateNTAQualifiedInvoiceIssuerInfoResolverResponse = _validateNTAQualifiedInvoiceIssuerInfoResolverResponse_v20240101;
})(v20240101 = exports.v20240101 || (exports.v20240101 = {}));
var getValidators = function (version) {
    if (version === '2022-09-01') {
        return v20220901;
    }
    else if (version === '2022-11-01') {
        return v20221101;
    }
    else if (version === '2023-09-01') {
        return v20230901;
    }
    else if (version === '2024-01-01') {
        return v20240101;
    }
    else {
        return compatible;
    }
};
exports.getValidators = getValidators;
function validate_NTACorporateInfoResolverResponse_v20240101(jsonObj) {
    var struct = superstruct.superstruct({ types: {} });
    var validator = struct({
        version: "string",
        data: {
            published_date: superstruct.struct.optional(superstruct.struct.union(["undefined", "string"])),
            sequence_number: "number",
            corporate_number: "string",
            process: superstruct.struct.union([superstruct.struct.literal(1), superstruct.struct.literal(11), superstruct.struct.literal(12), superstruct.struct.literal(13), superstruct.struct.literal(21), superstruct.struct.literal(22), superstruct.struct.literal(71), superstruct.struct.literal(72), superstruct.struct.literal(81), superstruct.struct.literal(99)]),
            correct: "number",
            update_date: "string",
            change_date: "string",
            name: "string",
            name_image_id: superstruct.struct.union(["null", "string"]),
            kind: superstruct.struct.union([superstruct.struct.literal(101), superstruct.struct.literal(201), superstruct.struct.literal(301), superstruct.struct.literal(302), superstruct.struct.literal(303), superstruct.struct.literal(304), superstruct.struct.literal(305), superstruct.struct.literal(399), superstruct.struct.literal(401), superstruct.struct.literal(499)]),
            address: {
                postal_code: superstruct.struct.union(["null", "string"]),
                jisx0402: superstruct.struct.union(["null", "string"]),
                prefecture: superstruct.struct.union(["null", "string"]),
                prefecture_kana: superstruct.struct.union(["null", "string"]),
                prefecture_roman: superstruct.struct.union(["null", "string"]),
                city: superstruct.struct.union(["null", "string"]),
                city_kana: superstruct.struct.union(["null", "string"]),
                city_roman: superstruct.struct.union(["null", "string"]),
                street_number: "string",
                town: superstruct.struct.union(["null", "string"]),
                kyoto_street: superstruct.struct.union(["null", "string"]),
                block_lot_num: superstruct.struct.union(["null", "string"]),
                building: superstruct.struct.union(["null", "string"]),
                floor_room: superstruct.struct.union(["null", "string"])
            },
            address_image_id: superstruct.struct.union(["null", "string"]),
            address_outside: "string",
            address_outside_image_id: superstruct.struct.union(["null", "string"]),
            close_date: superstruct.struct.union(["null", "string"]),
            close_cause: superstruct.struct.union(["null", superstruct.struct.literal("1"), superstruct.struct.literal("11"), superstruct.struct.literal("21"), superstruct.struct.literal("31")]),
            successor_corporate_number: superstruct.struct.union(["null", "string"]),
            change_cause: "string",
            assignment_date: "string",
            en_name: "string",
            en_address_line: superstruct.struct.union(["null", "string"]),
            en_address_outside: superstruct.struct.union(["null", "string"]),
            furigana: "string",
            hihyoji: "number",
            qualified_invoice_issuer_number: superstruct.struct.union(["null", "string"])
        }
    });
    return validator(jsonObj);
}
function validate_NTACorporateInfoSearcherResponse_v20240101(jsonObj) {
    var struct = superstruct.superstruct({ types: {} });
    var validator = struct({
        version: "string",
        data: superstruct.struct.array([{
                published_date: superstruct.struct.optional(superstruct.struct.union(["undefined", "string"])),
                sequence_number: "number",
                corporate_number: "string",
                process: superstruct.struct.union([superstruct.struct.literal(1), superstruct.struct.literal(11), superstruct.struct.literal(12), superstruct.struct.literal(13), superstruct.struct.literal(21), superstruct.struct.literal(22), superstruct.struct.literal(71), superstruct.struct.literal(72), superstruct.struct.literal(81), superstruct.struct.literal(99)]),
                correct: "number",
                update_date: "string",
                change_date: "string",
                name: "string",
                name_image_id: superstruct.struct.union(["null", "string"]),
                kind: superstruct.struct.union([superstruct.struct.literal(101), superstruct.struct.literal(201), superstruct.struct.literal(301), superstruct.struct.literal(302), superstruct.struct.literal(303), superstruct.struct.literal(304), superstruct.struct.literal(305), superstruct.struct.literal(399), superstruct.struct.literal(401), superstruct.struct.literal(499)]),
                address: {
                    postal_code: superstruct.struct.union(["null", "string"]),
                    jisx0402: superstruct.struct.union(["null", "string"]),
                    prefecture: superstruct.struct.union(["null", "string"]),
                    prefecture_kana: superstruct.struct.union(["null", "string"]),
                    prefecture_roman: superstruct.struct.union(["null", "string"]),
                    city: superstruct.struct.union(["null", "string"]),
                    city_kana: superstruct.struct.union(["null", "string"]),
                    city_roman: superstruct.struct.union(["null", "string"]),
                    street_number: "string",
                    town: superstruct.struct.union(["null", "string"]),
                    kyoto_street: superstruct.struct.union(["null", "string"]),
                    block_lot_num: superstruct.struct.union(["null", "string"]),
                    building: superstruct.struct.union(["null", "string"]),
                    floor_room: superstruct.struct.union(["null", "string"])
                },
                address_image_id: superstruct.struct.union(["null", "string"]),
                address_outside: "string",
                address_outside_image_id: superstruct.struct.union(["null", "string"]),
                close_date: superstruct.struct.union(["null", "string"]),
                close_cause: superstruct.struct.union(["null", superstruct.struct.literal("1"), superstruct.struct.literal("11"), superstruct.struct.literal("21"), superstruct.struct.literal("31")]),
                successor_corporate_number: superstruct.struct.union(["null", "string"]),
                change_cause: "string",
                assignment_date: "string",
                en_name: "string",
                en_address_line: superstruct.struct.union(["null", "string"]),
                en_address_outside: superstruct.struct.union(["null", "string"]),
                furigana: "string",
                hihyoji: "number",
                qualified_invoice_issuer_number: superstruct.struct.union(["null", "string"])
            }]),
        query: "string",
        count: "number",
        offset: "number",
        limit: "number",
        facets: superstruct.struct.union(["null", {
                area: superstruct.struct.optional(superstruct.struct.union(["undefined", superstruct.struct.tuple(["string", "number"])])),
                kind: superstruct.struct.optional(superstruct.struct.union(["undefined", superstruct.struct.tuple(["string", "number"])])),
                process: superstruct.struct.optional(superstruct.struct.union(["undefined", superstruct.struct.tuple(["string", "number"])])),
                close_cause: superstruct.struct.optional(superstruct.struct.union(["undefined", superstruct.struct.tuple(["string", "number"])]))
            }])
    });
    return validator(jsonObj);
}
function validate_NTAQualifiedInvoiceIssuerInfoResolverResponse_v20240101(jsonObj) {
    var struct = superstruct.superstruct({ types: {} });
    var validator = struct({
        version: "string",
        data: {
            published_date: "string",
            sequence_number: "number",
            qualified_invoice_issuer_number: "string",
            process: superstruct.struct.union([superstruct.struct.literal(1), superstruct.struct.literal(2), superstruct.struct.literal(3), superstruct.struct.literal(4), superstruct.struct.literal(99)]),
            correct: superstruct.struct.union(["null", superstruct.struct.literal(0), superstruct.struct.literal(1)]),
            kind: superstruct.struct.union([superstruct.struct.literal(1), superstruct.struct.literal(2)]),
            country: superstruct.struct.union([superstruct.struct.literal(1), superstruct.struct.literal(2), superstruct.struct.literal(3)]),
            latest: superstruct.struct.union([superstruct.struct.literal(0), superstruct.struct.literal(1)]),
            registration_date: superstruct.struct.union(["null", "string"]),
            update_date: superstruct.struct.union(["null", "string"]),
            disposal_date: superstruct.struct.union(["null", "string"]),
            expire_date: superstruct.struct.union(["null", "string"]),
            address: {
                postal_code: superstruct.struct.union(["null", "string"]),
                jisx0402: superstruct.struct.union(["null", "string"]),
                prefecture: superstruct.struct.union(["null", "string"]),
                prefecture_kana: superstruct.struct.union(["null", "string"]),
                prefecture_roman: superstruct.struct.union(["null", "string"]),
                city: superstruct.struct.union(["null", "string"]),
                city_kana: superstruct.struct.union(["null", "string"]),
                city_roman: superstruct.struct.union(["null", "string"]),
                street_number: "string",
                town: superstruct.struct.union(["null", "string"]),
                kyoto_street: superstruct.struct.union(["null", "string"]),
                block_lot_num: superstruct.struct.union(["null", "string"]),
                building: superstruct.struct.union(["null", "string"]),
                floor_room: superstruct.struct.union(["null", "string"])
            },
            address_request: {
                postal_code: superstruct.struct.union(["null", "string"]),
                jisx0402: superstruct.struct.union(["null", "string"]),
                prefecture: superstruct.struct.union(["null", "string"]),
                prefecture_kana: superstruct.struct.union(["null", "string"]),
                prefecture_roman: superstruct.struct.union(["null", "string"]),
                city: superstruct.struct.union(["null", "string"]),
                city_kana: superstruct.struct.union(["null", "string"]),
                city_roman: superstruct.struct.union(["null", "string"]),
                street_number: "string",
                town: superstruct.struct.union(["null", "string"]),
                kyoto_street: superstruct.struct.union(["null", "string"]),
                block_lot_num: superstruct.struct.union(["null", "string"]),
                building: superstruct.struct.union(["null", "string"]),
                floor_room: superstruct.struct.union(["null", "string"])
            },
            address_inside: {
                postal_code: superstruct.struct.union(["null", "string"]),
                jisx0402: superstruct.struct.union(["null", "string"]),
                prefecture: superstruct.struct.union(["null", "string"]),
                prefecture_kana: superstruct.struct.union(["null", "string"]),
                prefecture_roman: superstruct.struct.union(["null", "string"]),
                city: superstruct.struct.union(["null", "string"]),
                city_kana: superstruct.struct.union(["null", "string"]),
                city_roman: superstruct.struct.union(["null", "string"]),
                street_number: "string",
                town: superstruct.struct.union(["null", "string"]),
                kyoto_street: superstruct.struct.union(["null", "string"]),
                block_lot_num: superstruct.struct.union(["null", "string"]),
                building: superstruct.struct.union(["null", "string"]),
                floor_room: superstruct.struct.union(["null", "string"])
            },
            kana: superstruct.struct.union(["null", "string"]),
            name: superstruct.struct.union(["null", "string"]),
            trade_name: superstruct.struct.union(["null", "string"]),
            popular_name_previous_name: superstruct.struct.union(["null", "string"])
        }
    });
    return validator(jsonObj);
}
function validate_AddressResolverResponse_compatible(jsonObj) {
    var struct = superstruct.superstruct({ types: {} });
    var validator = struct({
        version: "string",
        data: superstruct.struct.array([superstruct.struct.intersection([superstruct.struct.interface({
                    jisx0402: "string",
                    old_code: "string",
                    postal_code: "string",
                    prefecture: "string",
                    prefecture_kana: "string",
                    prefecture_roman: superstruct.struct.optional(superstruct.struct.union(["undefined", "string"])),
                    city: "string",
                    city_kana: "string",
                    city_roman: superstruct.struct.optional(superstruct.struct.union(["undefined", "string"])),
                    county: superstruct.struct.optional(superstruct.struct.union(["undefined", "string"])),
                    county_kana: superstruct.struct.optional(superstruct.struct.union(["undefined", "string"])),
                    county_roman: superstruct.struct.optional(superstruct.struct.union(["undefined", "string"])),
                    city_without_county_and_ward: superstruct.struct.optional(superstruct.struct.union(["undefined", "string"])),
                    city_without_county_and_ward_kana: superstruct.struct.optional(superstruct.struct.union(["undefined", "string"])),
                    city_without_county_and_ward_roman: superstruct.struct.optional(superstruct.struct.union(["undefined", "string"])),
                    city_ward: superstruct.struct.optional(superstruct.struct.union(["undefined", "string"])),
                    city_ward_kana: superstruct.struct.optional(superstruct.struct.union(["undefined", "string"])),
                    city_ward_roman: superstruct.struct.optional(superstruct.struct.union(["undefined", "string"])),
                    town: "string",
                    town_kana: "string",
                    town_roman: superstruct.struct.optional(superstruct.struct.union(["undefined", "string"])),
                    town_raw: "string",
                    town_kana_raw: "string",
                    koaza: "string",
                    kyoto_street: superstruct.struct.union(["null", "string"]),
                    building: "string",
                    floor: "string",
                    town_partial: "boolean",
                    town_addressed_koaza: "boolean",
                    town_multi: "boolean",
                    town_chome: "boolean",
                    town_jukyohyoji: superstruct.struct.optional(superstruct.struct.union(["undefined", superstruct.struct.literal(false), superstruct.struct.literal(true)])),
                    update_status: superstruct.struct.optional(superstruct.struct.union(["undefined", superstruct.struct.literal(0), superstruct.struct.literal(1), superstruct.struct.literal(2)])),
                    update_reason: superstruct.struct.optional(superstruct.struct.union(["undefined", superstruct.struct.literal(0), superstruct.struct.literal(1), superstruct.struct.literal(2), superstruct.struct.literal(3), superstruct.struct.literal(4), superstruct.struct.literal(5), superstruct.struct.literal(6)])),
                    corporation: superstruct.struct.union(["null", superstruct.struct.intersection([superstruct.struct.interface({
                                name: "string",
                                name_kana: "string",
                                block_lot: "string",
                                block_lot_num: superstruct.struct.union(["null", "string"]),
                                post_office: "string",
                                code_type: "number"
                            }), superstruct.struct.record(["string", "any"])])])
                }), superstruct.struct.record(["string", "any"])])])
    });
    return validator(jsonObj);
}
function validate_CityResolverResponse_compatible(jsonObj) {
    var struct = superstruct.superstruct({ types: {} });
    var validator = struct({
        version: "string",
        data: superstruct.struct.array([superstruct.struct.intersection([superstruct.struct.interface({
                    jisx0402: "string",
                    prefecture_code: "string",
                    prefecture: "string",
                    prefecture_kana: "string",
                    prefecture_roman: superstruct.struct.optional(superstruct.struct.union(["undefined", "string"])),
                    city_code: "string",
                    city: "string",
                    city_kana: "string",
                    city_roman: superstruct.struct.optional(superstruct.struct.union(["undefined", "string"]))
                }), superstruct.struct.record(["string", "any"])])])
    });
    return validator(jsonObj);
}
function validate_AddressSearcherResponse_compatible(jsonObj) {
    var struct = superstruct.superstruct({ types: {} });
    var validator = struct({
        query: {
            q: superstruct.struct.union(["null", "string"]),
            t: superstruct.struct.union(["null", "string"]),
            prefecture: superstruct.struct.union(["null", "string"]),
            county: superstruct.struct.union(["null", "string"]),
            city: superstruct.struct.union(["null", "string"]),
            city_ward: superstruct.struct.union(["null", "string"]),
            town: superstruct.struct.union(["null", "string"]),
            kyoto_street: superstruct.struct.union(["null", "string"]),
            block_lot_num: superstruct.struct.union(["null", "string"]),
            building: superstruct.struct.union(["null", "string"]),
            floor_room: superstruct.struct.union(["null", "string"])
        },
        count: "number",
        offset: "number",
        limit: "number",
        facets: superstruct.struct.union(["null", superstruct.struct.array([superstruct.struct.tuple(["string", "number"])])]),
        version: "string",
        data: superstruct.struct.array([superstruct.struct.intersection([superstruct.struct.interface({
                    jisx0402: "string",
                    old_code: "string",
                    postal_code: "string",
                    prefecture: "string",
                    prefecture_kana: "string",
                    prefecture_roman: superstruct.struct.optional(superstruct.struct.union(["undefined", "string"])),
                    city: "string",
                    city_kana: "string",
                    city_roman: superstruct.struct.optional(superstruct.struct.union(["undefined", "string"])),
                    county: superstruct.struct.optional(superstruct.struct.union(["undefined", "string"])),
                    county_kana: superstruct.struct.optional(superstruct.struct.union(["undefined", "string"])),
                    county_roman: superstruct.struct.optional(superstruct.struct.union(["undefined", "string"])),
                    city_without_county_and_ward: superstruct.struct.optional(superstruct.struct.union(["undefined", "string"])),
                    city_without_county_and_ward_kana: superstruct.struct.optional(superstruct.struct.union(["undefined", "string"])),
                    city_without_county_and_ward_roman: superstruct.struct.optional(superstruct.struct.union(["undefined", "string"])),
                    city_ward: superstruct.struct.optional(superstruct.struct.union(["undefined", "string"])),
                    city_ward_kana: superstruct.struct.optional(superstruct.struct.union(["undefined", "string"])),
                    city_ward_roman: superstruct.struct.optional(superstruct.struct.union(["undefined", "string"])),
                    town: "string",
                    town_kana: "string",
                    town_roman: superstruct.struct.optional(superstruct.struct.union(["undefined", "string"])),
                    town_raw: "string",
                    town_kana_raw: "string",
                    koaza: "string",
                    kyoto_street: superstruct.struct.union(["null", "string"]),
                    building: "string",
                    floor: "string",
                    town_partial: "boolean",
                    town_addressed_koaza: "boolean",
                    town_multi: "boolean",
                    town_chome: "boolean",
                    town_jukyohyoji: superstruct.struct.optional(superstruct.struct.union(["undefined", superstruct.struct.literal(false), superstruct.struct.literal(true)])),
                    update_status: superstruct.struct.optional(superstruct.struct.union(["undefined", superstruct.struct.literal(0), superstruct.struct.literal(1), superstruct.struct.literal(2)])),
                    update_reason: superstruct.struct.optional(superstruct.struct.union(["undefined", superstruct.struct.literal(0), superstruct.struct.literal(1), superstruct.struct.literal(2), superstruct.struct.literal(3), superstruct.struct.literal(4), superstruct.struct.literal(5), superstruct.struct.literal(6)])),
                    corporation: superstruct.struct.union(["null", superstruct.struct.intersection([superstruct.struct.interface({
                                name: "string",
                                name_kana: "string",
                                block_lot: "string",
                                block_lot_num: superstruct.struct.union(["null", "string"]),
                                post_office: "string",
                                code_type: "number"
                            }), superstruct.struct.record(["string", "any"])])])
                }), superstruct.struct.record(["string", "any"])])])
    });
    return validator(jsonObj);
}
function validate_NTACorporateInfoResolverResponse_compatible(jsonObj) {
    var struct = superstruct.superstruct({ types: {} });
    var validator = struct({
        version: "string",
        data: {
            published_date: superstruct.struct.optional(superstruct.struct.union(["undefined", "string"])),
            sequence_number: "string",
            corporate_number: "string",
            process: superstruct.struct.union([superstruct.struct.literal("1"), superstruct.struct.literal("11"), superstruct.struct.literal("12"), superstruct.struct.literal("13"), superstruct.struct.literal("21"), superstruct.struct.literal("22"), superstruct.struct.literal("71"), superstruct.struct.literal("72"), superstruct.struct.literal("81"), superstruct.struct.literal("99")]),
            correct: "string",
            update_date: "string",
            change_date: "string",
            name: "string",
            name_image_id: superstruct.struct.union(["null", "string"]),
            kind: superstruct.struct.union([superstruct.struct.literal("101"), superstruct.struct.literal("201"), superstruct.struct.literal("301"), superstruct.struct.literal("302"), superstruct.struct.literal("303"), superstruct.struct.literal("304"), superstruct.struct.literal("305"), superstruct.struct.literal("399"), superstruct.struct.literal("401"), superstruct.struct.literal("499")]),
            prefecture_name: superstruct.struct.union(["null", "string"]),
            city_name: superstruct.struct.union(["null", "string"]),
            street_number: "string",
            town: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
            kyoto_street: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
            block_lot_num: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
            building: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
            floor_room: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
            address_image_id: superstruct.struct.union(["null", "string"]),
            jisx0402: superstruct.struct.union(["null", "string"]),
            post_code: superstruct.struct.union(["null", "string"]),
            address_outside: "string",
            address_outside_image_id: superstruct.struct.union(["null", "string"]),
            close_date: superstruct.struct.union(["null", "string"]),
            close_cause: superstruct.struct.union(["null", superstruct.struct.literal("1"), superstruct.struct.literal("11"), superstruct.struct.literal("21"), superstruct.struct.literal("31")]),
            successor_corporate_number: superstruct.struct.union(["null", "string"]),
            change_cause: "string",
            assignment_date: "string",
            en_name: "string",
            en_prefecture_name: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
            en_address_line: superstruct.struct.union(["null", "string"]),
            en_address_outside: superstruct.struct.union(["null", "string"]),
            furigana: "string",
            hihyoji: "string"
        }
    });
    return validator(jsonObj);
}
function validate_NTACorporateInfoSearcherResponse_compatible(jsonObj) {
    var struct = superstruct.superstruct({ types: {} });
    var validator = struct({
        version: "string",
        data: superstruct.struct.array([{
                published_date: superstruct.struct.optional(superstruct.struct.union(["undefined", "string"])),
                sequence_number: "string",
                corporate_number: "string",
                process: superstruct.struct.union([superstruct.struct.literal("1"), superstruct.struct.literal("11"), superstruct.struct.literal("12"), superstruct.struct.literal("13"), superstruct.struct.literal("21"), superstruct.struct.literal("22"), superstruct.struct.literal("71"), superstruct.struct.literal("72"), superstruct.struct.literal("81"), superstruct.struct.literal("99")]),
                correct: "string",
                update_date: "string",
                change_date: "string",
                name: "string",
                name_image_id: superstruct.struct.union(["null", "string"]),
                kind: superstruct.struct.union([superstruct.struct.literal("101"), superstruct.struct.literal("201"), superstruct.struct.literal("301"), superstruct.struct.literal("302"), superstruct.struct.literal("303"), superstruct.struct.literal("304"), superstruct.struct.literal("305"), superstruct.struct.literal("399"), superstruct.struct.literal("401"), superstruct.struct.literal("499")]),
                prefecture_name: superstruct.struct.union(["null", "string"]),
                city_name: superstruct.struct.union(["null", "string"]),
                street_number: "string",
                town: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
                kyoto_street: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
                block_lot_num: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
                building: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
                floor_room: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
                address_image_id: superstruct.struct.union(["null", "string"]),
                jisx0402: superstruct.struct.union(["null", "string"]),
                post_code: superstruct.struct.union(["null", "string"]),
                address_outside: "string",
                address_outside_image_id: superstruct.struct.union(["null", "string"]),
                close_date: superstruct.struct.union(["null", "string"]),
                close_cause: superstruct.struct.union(["null", superstruct.struct.literal("1"), superstruct.struct.literal("11"), superstruct.struct.literal("21"), superstruct.struct.literal("31")]),
                successor_corporate_number: superstruct.struct.union(["null", "string"]),
                change_cause: "string",
                assignment_date: "string",
                en_name: "string",
                en_prefecture_name: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
                en_address_line: superstruct.struct.union(["null", "string"]),
                en_address_outside: superstruct.struct.union(["null", "string"]),
                furigana: "string",
                hihyoji: "string"
            }]),
        query: "string",
        count: "number",
        offset: "number",
        limit: "number",
        facets: superstruct.struct.union(["null", {
                area: superstruct.struct.optional(superstruct.struct.union(["undefined", superstruct.struct.tuple(["string", "number"])])),
                kind: superstruct.struct.optional(superstruct.struct.union(["undefined", superstruct.struct.tuple(["string", "number"])])),
                process: superstruct.struct.optional(superstruct.struct.union(["undefined", superstruct.struct.tuple(["string", "number"])])),
                close_cause: superstruct.struct.optional(superstruct.struct.union(["undefined", superstruct.struct.tuple(["string", "number"])]))
            }])
    });
    return validator(jsonObj);
}
function validate_AddressResolverResponse_v20220901(jsonObj) {
    var struct = superstruct.superstruct({ types: {} });
    var validator = struct({
        version: "string",
        data: superstruct.struct.array([{
                jisx0402: "string",
                old_code: "string",
                postal_code: "string",
                prefecture: "string",
                prefecture_kana: "string",
                city: "string",
                city_kana: "string",
                town: "string",
                town_kana: "string",
                town_raw: "string",
                town_kana_raw: "string",
                koaza: "string",
                kyoto_street: superstruct.struct.union(["null", "string"]),
                building: "string",
                floor: "string",
                town_partial: "boolean",
                town_addressed_koaza: "boolean",
                town_multi: "boolean",
                town_chome: "boolean",
                corporation: superstruct.struct.union(["null", {
                        name: "string",
                        name_kana: "string",
                        block_lot: "string",
                        block_lot_num: superstruct.struct.union(["null", "string"]),
                        post_office: "string",
                        code_type: "number"
                    }])
            }])
    });
    return validator(jsonObj);
}
function validate_CityResolverResponse_v20220901(jsonObj) {
    var struct = superstruct.superstruct({ types: {} });
    var validator = struct({
        version: "string",
        data: superstruct.struct.array([{
                jisx0402: "string",
                prefecture_code: "string",
                prefecture: "string",
                prefecture_kana: "string",
                city_code: "string",
                city: "string",
                city_kana: "string"
            }])
    });
    return validator(jsonObj);
}
function validate_AddressSearcherResponse_v20220901(jsonObj) {
    var struct = superstruct.superstruct({ types: {} });
    var validator = struct({
        query: {
            q: superstruct.struct.union(["null", "string"]),
            t: superstruct.struct.union(["null", "string"]),
            prefecture: superstruct.struct.union(["null", "string"]),
            county: superstruct.struct.union(["null", "string"]),
            city: superstruct.struct.union(["null", "string"]),
            city_ward: superstruct.struct.union(["null", "string"]),
            town: superstruct.struct.union(["null", "string"]),
            kyoto_street: superstruct.struct.union(["null", "string"]),
            block_lot_num: superstruct.struct.union(["null", "string"]),
            building: superstruct.struct.union(["null", "string"]),
            floor_room: superstruct.struct.union(["null", "string"])
        },
        count: "number",
        offset: "number",
        limit: "number",
        facets: superstruct.struct.union(["null", superstruct.struct.array([superstruct.struct.tuple(["string", "number"])])]),
        version: "string",
        data: superstruct.struct.array([{
                jisx0402: "string",
                old_code: "string",
                postal_code: "string",
                prefecture: "string",
                prefecture_kana: "string",
                city: "string",
                city_kana: "string",
                town: "string",
                town_kana: "string",
                town_raw: "string",
                town_kana_raw: "string",
                koaza: "string",
                kyoto_street: superstruct.struct.union(["null", "string"]),
                building: "string",
                floor: "string",
                town_partial: "boolean",
                town_addressed_koaza: "boolean",
                town_multi: "boolean",
                town_chome: "boolean",
                corporation: superstruct.struct.union(["null", {
                        name: "string",
                        name_kana: "string",
                        block_lot: "string",
                        block_lot_num: superstruct.struct.union(["null", "string"]),
                        post_office: "string",
                        code_type: "number"
                    }])
            }])
    });
    return validator(jsonObj);
}
function validate_NTACorporateInfoResolverResponse_v20220901(jsonObj) {
    var struct = superstruct.superstruct({ types: {} });
    var validator = struct({
        version: "string",
        data: {
            published_date: superstruct.struct.optional(superstruct.struct.union(["undefined", "string"])),
            sequence_number: "string",
            corporate_number: "string",
            process: superstruct.struct.union([superstruct.struct.literal("1"), superstruct.struct.literal("11"), superstruct.struct.literal("12"), superstruct.struct.literal("13"), superstruct.struct.literal("21"), superstruct.struct.literal("22"), superstruct.struct.literal("71"), superstruct.struct.literal("72"), superstruct.struct.literal("81"), superstruct.struct.literal("99")]),
            correct: "string",
            update_date: "string",
            change_date: "string",
            name: "string",
            name_image_id: superstruct.struct.union(["null", "string"]),
            kind: superstruct.struct.union([superstruct.struct.literal("101"), superstruct.struct.literal("201"), superstruct.struct.literal("301"), superstruct.struct.literal("302"), superstruct.struct.literal("303"), superstruct.struct.literal("304"), superstruct.struct.literal("305"), superstruct.struct.literal("399"), superstruct.struct.literal("401"), superstruct.struct.literal("499")]),
            prefecture_name: superstruct.struct.union(["null", "string"]),
            city_name: superstruct.struct.union(["null", "string"]),
            street_number: "string",
            town: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
            kyoto_street: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
            block_lot_num: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
            building: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
            floor_room: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
            address_image_id: superstruct.struct.union(["null", "string"]),
            jisx0402: superstruct.struct.union(["null", "string"]),
            post_code: superstruct.struct.union(["null", "string"]),
            address_outside: "string",
            address_outside_image_id: superstruct.struct.union(["null", "string"]),
            close_date: superstruct.struct.union(["null", "string"]),
            close_cause: superstruct.struct.union(["null", superstruct.struct.literal("1"), superstruct.struct.literal("11"), superstruct.struct.literal("21"), superstruct.struct.literal("31")]),
            successor_corporate_number: superstruct.struct.union(["null", "string"]),
            change_cause: "string",
            assignment_date: "string",
            en_name: "string",
            en_prefecture_name: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
            en_address_line: superstruct.struct.union(["null", "string"]),
            en_address_outside: superstruct.struct.union(["null", "string"]),
            furigana: "string",
            hihyoji: "string"
        }
    });
    return validator(jsonObj);
}
function validate_NTACorporateInfoSearcherResponse_v20220901(jsonObj) {
    var struct = superstruct.superstruct({ types: {} });
    var validator = struct({
        version: "string",
        data: superstruct.struct.array([{
                published_date: superstruct.struct.optional(superstruct.struct.union(["undefined", "string"])),
                sequence_number: "string",
                corporate_number: "string",
                process: superstruct.struct.union([superstruct.struct.literal("1"), superstruct.struct.literal("11"), superstruct.struct.literal("12"), superstruct.struct.literal("13"), superstruct.struct.literal("21"), superstruct.struct.literal("22"), superstruct.struct.literal("71"), superstruct.struct.literal("72"), superstruct.struct.literal("81"), superstruct.struct.literal("99")]),
                correct: "string",
                update_date: "string",
                change_date: "string",
                name: "string",
                name_image_id: superstruct.struct.union(["null", "string"]),
                kind: superstruct.struct.union([superstruct.struct.literal("101"), superstruct.struct.literal("201"), superstruct.struct.literal("301"), superstruct.struct.literal("302"), superstruct.struct.literal("303"), superstruct.struct.literal("304"), superstruct.struct.literal("305"), superstruct.struct.literal("399"), superstruct.struct.literal("401"), superstruct.struct.literal("499")]),
                prefecture_name: superstruct.struct.union(["null", "string"]),
                city_name: superstruct.struct.union(["null", "string"]),
                street_number: "string",
                town: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
                kyoto_street: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
                block_lot_num: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
                building: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
                floor_room: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
                address_image_id: superstruct.struct.union(["null", "string"]),
                jisx0402: superstruct.struct.union(["null", "string"]),
                post_code: superstruct.struct.union(["null", "string"]),
                address_outside: "string",
                address_outside_image_id: superstruct.struct.union(["null", "string"]),
                close_date: superstruct.struct.union(["null", "string"]),
                close_cause: superstruct.struct.union(["null", superstruct.struct.literal("1"), superstruct.struct.literal("11"), superstruct.struct.literal("21"), superstruct.struct.literal("31")]),
                successor_corporate_number: superstruct.struct.union(["null", "string"]),
                change_cause: "string",
                assignment_date: "string",
                en_name: "string",
                en_prefecture_name: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
                en_address_line: superstruct.struct.union(["null", "string"]),
                en_address_outside: superstruct.struct.union(["null", "string"]),
                furigana: "string",
                hihyoji: "string"
            }]),
        query: "string",
        count: "number",
        offset: "number",
        limit: "number",
        facets: superstruct.struct.union(["null", {
                area: superstruct.struct.optional(superstruct.struct.union(["undefined", superstruct.struct.tuple(["string", "number"])])),
                kind: superstruct.struct.optional(superstruct.struct.union(["undefined", superstruct.struct.tuple(["string", "number"])])),
                process: superstruct.struct.optional(superstruct.struct.union(["undefined", superstruct.struct.tuple(["string", "number"])])),
                close_cause: superstruct.struct.optional(superstruct.struct.union(["undefined", superstruct.struct.tuple(["string", "number"])]))
            }])
    });
    return validator(jsonObj);
}
function validate_AddressResolverResponse_v20221101(jsonObj) {
    var struct = superstruct.superstruct({ types: {} });
    var validator = struct({
        version: "string",
        data: superstruct.struct.array([{
                jisx0402: "string",
                old_code: "string",
                postal_code: "string",
                prefecture: "string",
                prefecture_kana: "string",
                prefecture_roman: "string",
                city: "string",
                city_kana: "string",
                city_roman: "string",
                county: "string",
                county_kana: "string",
                county_roman: "string",
                city_without_county_and_ward: "string",
                city_without_county_and_ward_kana: "string",
                city_without_county_and_ward_roman: "string",
                city_ward: "string",
                city_ward_kana: "string",
                city_ward_roman: "string",
                town: "string",
                town_kana: "string",
                town_roman: "string",
                town_raw: "string",
                town_kana_raw: "string",
                koaza: "string",
                kyoto_street: superstruct.struct.union(["null", "string"]),
                building: "string",
                floor: "string",
                town_partial: "boolean",
                town_addressed_koaza: "boolean",
                town_multi: "boolean",
                town_chome: "boolean",
                town_jukyohyoji: "boolean",
                update_status: superstruct.struct.union([superstruct.struct.literal(0), superstruct.struct.literal(1), superstruct.struct.literal(2)]),
                update_reason: superstruct.struct.union([superstruct.struct.literal(0), superstruct.struct.literal(1), superstruct.struct.literal(2), superstruct.struct.literal(3), superstruct.struct.literal(4), superstruct.struct.literal(5), superstruct.struct.literal(6)]),
                corporation: superstruct.struct.union(["null", {
                        name: "string",
                        name_kana: "string",
                        block_lot: "string",
                        block_lot_num: superstruct.struct.union(["null", "string"]),
                        post_office: "string",
                        code_type: "number"
                    }])
            }])
    });
    return validator(jsonObj);
}
function validate_CityResolverResponse_v20221101(jsonObj) {
    var struct = superstruct.superstruct({ types: {} });
    var validator = struct({
        version: "string",
        data: superstruct.struct.array([{
                jisx0402: "string",
                prefecture_code: "string",
                prefecture: "string",
                prefecture_kana: "string",
                prefecture_roman: "string",
                city_code: "string",
                city: "string",
                city_kana: "string",
                city_roman: "string"
            }])
    });
    return validator(jsonObj);
}
function validate_AddressSearcherResponse_v20221101(jsonObj) {
    var struct = superstruct.superstruct({ types: {} });
    var validator = struct({
        query: {
            q: superstruct.struct.union(["null", "string"]),
            t: superstruct.struct.union(["null", "string"]),
            prefecture: superstruct.struct.union(["null", "string"]),
            county: superstruct.struct.union(["null", "string"]),
            city: superstruct.struct.union(["null", "string"]),
            city_ward: superstruct.struct.union(["null", "string"]),
            town: superstruct.struct.union(["null", "string"]),
            kyoto_street: superstruct.struct.union(["null", "string"]),
            block_lot_num: superstruct.struct.union(["null", "string"]),
            building: superstruct.struct.union(["null", "string"]),
            floor_room: superstruct.struct.union(["null", "string"])
        },
        count: "number",
        offset: "number",
        limit: "number",
        facets: superstruct.struct.union(["null", superstruct.struct.array([superstruct.struct.tuple(["string", "number"])])]),
        version: "string",
        data: superstruct.struct.array([{
                jisx0402: "string",
                old_code: "string",
                postal_code: "string",
                prefecture: "string",
                prefecture_kana: "string",
                prefecture_roman: "string",
                city: "string",
                city_kana: "string",
                city_roman: "string",
                county: "string",
                county_kana: "string",
                county_roman: "string",
                city_without_county_and_ward: "string",
                city_without_county_and_ward_kana: "string",
                city_without_county_and_ward_roman: "string",
                city_ward: "string",
                city_ward_kana: "string",
                city_ward_roman: "string",
                town: "string",
                town_kana: "string",
                town_roman: "string",
                town_raw: "string",
                town_kana_raw: "string",
                koaza: "string",
                kyoto_street: superstruct.struct.union(["null", "string"]),
                building: "string",
                floor: "string",
                town_partial: "boolean",
                town_addressed_koaza: "boolean",
                town_multi: "boolean",
                town_chome: "boolean",
                town_jukyohyoji: "boolean",
                update_status: superstruct.struct.union([superstruct.struct.literal(0), superstruct.struct.literal(1), superstruct.struct.literal(2)]),
                update_reason: superstruct.struct.union([superstruct.struct.literal(0), superstruct.struct.literal(1), superstruct.struct.literal(2), superstruct.struct.literal(3), superstruct.struct.literal(4), superstruct.struct.literal(5), superstruct.struct.literal(6)]),
                corporation: superstruct.struct.union(["null", {
                        name: "string",
                        name_kana: "string",
                        block_lot: "string",
                        block_lot_num: superstruct.struct.union(["null", "string"]),
                        post_office: "string",
                        code_type: "number"
                    }])
            }])
    });
    return validator(jsonObj);
}
function validate_NTACorporateInfoResolverResponse_v20221101(jsonObj) {
    var struct = superstruct.superstruct({ types: {} });
    var validator = struct({
        version: "string",
        data: {
            published_date: superstruct.struct.optional(superstruct.struct.union(["undefined", "string"])),
            sequence_number: "string",
            corporate_number: "string",
            process: superstruct.struct.union([superstruct.struct.literal("1"), superstruct.struct.literal("11"), superstruct.struct.literal("12"), superstruct.struct.literal("13"), superstruct.struct.literal("21"), superstruct.struct.literal("22"), superstruct.struct.literal("71"), superstruct.struct.literal("72"), superstruct.struct.literal("81"), superstruct.struct.literal("99")]),
            correct: "string",
            update_date: "string",
            change_date: "string",
            name: "string",
            name_image_id: superstruct.struct.union(["null", "string"]),
            kind: superstruct.struct.union([superstruct.struct.literal("101"), superstruct.struct.literal("201"), superstruct.struct.literal("301"), superstruct.struct.literal("302"), superstruct.struct.literal("303"), superstruct.struct.literal("304"), superstruct.struct.literal("305"), superstruct.struct.literal("399"), superstruct.struct.literal("401"), superstruct.struct.literal("499")]),
            prefecture_name: superstruct.struct.union(["null", "string"]),
            city_name: superstruct.struct.union(["null", "string"]),
            street_number: "string",
            town: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
            kyoto_street: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
            block_lot_num: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
            building: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
            floor_room: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
            address_image_id: superstruct.struct.union(["null", "string"]),
            jisx0402: superstruct.struct.union(["null", "string"]),
            post_code: superstruct.struct.union(["null", "string"]),
            address_outside: "string",
            address_outside_image_id: superstruct.struct.union(["null", "string"]),
            close_date: superstruct.struct.union(["null", "string"]),
            close_cause: superstruct.struct.union(["null", superstruct.struct.literal("1"), superstruct.struct.literal("11"), superstruct.struct.literal("21"), superstruct.struct.literal("31")]),
            successor_corporate_number: superstruct.struct.union(["null", "string"]),
            change_cause: "string",
            assignment_date: "string",
            en_name: "string",
            en_prefecture_name: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
            en_address_line: superstruct.struct.union(["null", "string"]),
            en_address_outside: superstruct.struct.union(["null", "string"]),
            furigana: "string",
            hihyoji: "string"
        }
    });
    return validator(jsonObj);
}
function validate_NTACorporateInfoSearcherResponse_v20221101(jsonObj) {
    var struct = superstruct.superstruct({ types: {} });
    var validator = struct({
        version: "string",
        data: superstruct.struct.array([{
                published_date: superstruct.struct.optional(superstruct.struct.union(["undefined", "string"])),
                sequence_number: "string",
                corporate_number: "string",
                process: superstruct.struct.union([superstruct.struct.literal("1"), superstruct.struct.literal("11"), superstruct.struct.literal("12"), superstruct.struct.literal("13"), superstruct.struct.literal("21"), superstruct.struct.literal("22"), superstruct.struct.literal("71"), superstruct.struct.literal("72"), superstruct.struct.literal("81"), superstruct.struct.literal("99")]),
                correct: "string",
                update_date: "string",
                change_date: "string",
                name: "string",
                name_image_id: superstruct.struct.union(["null", "string"]),
                kind: superstruct.struct.union([superstruct.struct.literal("101"), superstruct.struct.literal("201"), superstruct.struct.literal("301"), superstruct.struct.literal("302"), superstruct.struct.literal("303"), superstruct.struct.literal("304"), superstruct.struct.literal("305"), superstruct.struct.literal("399"), superstruct.struct.literal("401"), superstruct.struct.literal("499")]),
                prefecture_name: superstruct.struct.union(["null", "string"]),
                city_name: superstruct.struct.union(["null", "string"]),
                street_number: "string",
                town: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
                kyoto_street: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
                block_lot_num: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
                building: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
                floor_room: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
                address_image_id: superstruct.struct.union(["null", "string"]),
                jisx0402: superstruct.struct.union(["null", "string"]),
                post_code: superstruct.struct.union(["null", "string"]),
                address_outside: "string",
                address_outside_image_id: superstruct.struct.union(["null", "string"]),
                close_date: superstruct.struct.union(["null", "string"]),
                close_cause: superstruct.struct.union(["null", superstruct.struct.literal("1"), superstruct.struct.literal("11"), superstruct.struct.literal("21"), superstruct.struct.literal("31")]),
                successor_corporate_number: superstruct.struct.union(["null", "string"]),
                change_cause: "string",
                assignment_date: "string",
                en_name: "string",
                en_prefecture_name: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
                en_address_line: superstruct.struct.union(["null", "string"]),
                en_address_outside: superstruct.struct.union(["null", "string"]),
                furigana: "string",
                hihyoji: "string"
            }]),
        query: "string",
        count: "number",
        offset: "number",
        limit: "number",
        facets: superstruct.struct.union(["null", {
                area: superstruct.struct.optional(superstruct.struct.union(["undefined", superstruct.struct.tuple(["string", "number"])])),
                kind: superstruct.struct.optional(superstruct.struct.union(["undefined", superstruct.struct.tuple(["string", "number"])])),
                process: superstruct.struct.optional(superstruct.struct.union(["undefined", superstruct.struct.tuple(["string", "number"])])),
                close_cause: superstruct.struct.optional(superstruct.struct.union(["undefined", superstruct.struct.tuple(["string", "number"])]))
            }])
    });
    return validator(jsonObj);
}
function validate_AddressResolverResponse_v20230901(jsonObj) {
    var struct = superstruct.superstruct({ types: {} });
    var validator = struct({
        version: "string",
        data: superstruct.struct.array([{
                jisx0402: "string",
                old_code: "string",
                postal_code: "string",
                prefecture: "string",
                prefecture_kana: "string",
                prefecture_roman: "string",
                city: "string",
                city_kana: "string",
                city_roman: "string",
                county: "string",
                county_kana: "string",
                county_roman: "string",
                city_without_county_and_ward: "string",
                city_without_county_and_ward_kana: "string",
                city_without_county_and_ward_roman: "string",
                city_ward: "string",
                city_ward_kana: "string",
                city_ward_roman: "string",
                town: "string",
                town_kana: "string",
                town_roman: "string",
                town_raw: "string",
                town_kana_raw: "string",
                koaza: "string",
                kyoto_street: superstruct.struct.union(["null", "string"]),
                building: "string",
                floor: "string",
                town_partial: "boolean",
                town_addressed_koaza: "boolean",
                town_multi: "boolean",
                town_chome: "boolean",
                town_jukyohyoji: "boolean",
                update_status: superstruct.struct.union([superstruct.struct.literal(0), superstruct.struct.literal(1), superstruct.struct.literal(2)]),
                update_reason: superstruct.struct.union([superstruct.struct.literal(0), superstruct.struct.literal(1), superstruct.struct.literal(2), superstruct.struct.literal(3), superstruct.struct.literal(4), superstruct.struct.literal(5), superstruct.struct.literal(6)]),
                corporation: superstruct.struct.union(["null", {
                        name: "string",
                        name_kana: "string",
                        block_lot: "string",
                        block_lot_num: superstruct.struct.union(["null", "string"]),
                        post_office: "string",
                        code_type: "number"
                    }])
            }])
    });
    return validator(jsonObj);
}
function validate_CityResolverResponse_v20230901(jsonObj) {
    var struct = superstruct.superstruct({ types: {} });
    var validator = struct({
        version: "string",
        data: superstruct.struct.array([{
                jisx0402: "string",
                prefecture_code: "string",
                prefecture: "string",
                prefecture_kana: "string",
                prefecture_roman: "string",
                city_code: "string",
                city: "string",
                city_kana: "string",
                city_roman: "string",
                county: "string",
                county_kana: "string",
                county_roman: "string",
                city_without_county_and_ward: "string",
                city_without_county_and_ward_kana: "string",
                city_without_county_and_ward_roman: "string"
            }])
    });
    return validator(jsonObj);
}
function validate_AddressSearcherResponse_v20230901(jsonObj) {
    var struct = superstruct.superstruct({ types: {} });
    var validator = struct({
        query: {
            q: superstruct.struct.union(["null", "string"]),
            t: superstruct.struct.union(["null", "string"]),
            prefecture: superstruct.struct.union(["null", "string"]),
            county: superstruct.struct.union(["null", "string"]),
            city: superstruct.struct.union(["null", "string"]),
            city_ward: superstruct.struct.union(["null", "string"]),
            town: superstruct.struct.union(["null", "string"]),
            kyoto_street: superstruct.struct.union(["null", "string"]),
            block_lot_num: superstruct.struct.union(["null", "string"]),
            building: superstruct.struct.union(["null", "string"]),
            floor_room: superstruct.struct.union(["null", "string"])
        },
        count: "number",
        offset: "number",
        limit: "number",
        facets: superstruct.struct.union(["null", superstruct.struct.array([superstruct.struct.tuple(["string", "number"])])]),
        version: "string",
        data: superstruct.struct.array([{
                jisx0402: "string",
                old_code: "string",
                postal_code: "string",
                prefecture: "string",
                prefecture_kana: "string",
                prefecture_roman: "string",
                city: "string",
                city_kana: "string",
                city_roman: "string",
                county: "string",
                county_kana: "string",
                county_roman: "string",
                city_without_county_and_ward: "string",
                city_without_county_and_ward_kana: "string",
                city_without_county_and_ward_roman: "string",
                city_ward: "string",
                city_ward_kana: "string",
                city_ward_roman: "string",
                town: "string",
                town_kana: "string",
                town_roman: "string",
                town_raw: "string",
                town_kana_raw: "string",
                koaza: "string",
                kyoto_street: superstruct.struct.union(["null", "string"]),
                building: "string",
                floor: "string",
                town_partial: "boolean",
                town_addressed_koaza: "boolean",
                town_multi: "boolean",
                town_chome: "boolean",
                town_jukyohyoji: "boolean",
                update_status: superstruct.struct.union([superstruct.struct.literal(0), superstruct.struct.literal(1), superstruct.struct.literal(2)]),
                update_reason: superstruct.struct.union([superstruct.struct.literal(0), superstruct.struct.literal(1), superstruct.struct.literal(2), superstruct.struct.literal(3), superstruct.struct.literal(4), superstruct.struct.literal(5), superstruct.struct.literal(6)]),
                corporation: superstruct.struct.union(["null", {
                        name: "string",
                        name_kana: "string",
                        block_lot: "string",
                        block_lot_num: superstruct.struct.union(["null", "string"]),
                        post_office: "string",
                        code_type: "number"
                    }])
            }])
    });
    return validator(jsonObj);
}
function validate_NTACorporateInfoResolverResponse_v20230901(jsonObj) {
    var struct = superstruct.superstruct({ types: {} });
    var validator = struct({
        version: "string",
        data: {
            published_date: superstruct.struct.optional(superstruct.struct.union(["undefined", "string"])),
            sequence_number: "string",
            corporate_number: "string",
            process: superstruct.struct.union([superstruct.struct.literal("1"), superstruct.struct.literal("11"), superstruct.struct.literal("12"), superstruct.struct.literal("13"), superstruct.struct.literal("21"), superstruct.struct.literal("22"), superstruct.struct.literal("71"), superstruct.struct.literal("72"), superstruct.struct.literal("81"), superstruct.struct.literal("99")]),
            correct: "string",
            update_date: "string",
            change_date: "string",
            name: "string",
            name_image_id: superstruct.struct.union(["null", "string"]),
            kind: superstruct.struct.union([superstruct.struct.literal("101"), superstruct.struct.literal("201"), superstruct.struct.literal("301"), superstruct.struct.literal("302"), superstruct.struct.literal("303"), superstruct.struct.literal("304"), superstruct.struct.literal("305"), superstruct.struct.literal("399"), superstruct.struct.literal("401"), superstruct.struct.literal("499")]),
            prefecture_name: superstruct.struct.union(["null", "string"]),
            city_name: superstruct.struct.union(["null", "string"]),
            street_number: "string",
            town: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
            kyoto_street: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
            block_lot_num: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
            building: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
            floor_room: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
            address_image_id: superstruct.struct.union(["null", "string"]),
            jisx0402: superstruct.struct.union(["null", "string"]),
            post_code: superstruct.struct.union(["null", "string"]),
            address_outside: "string",
            address_outside_image_id: superstruct.struct.union(["null", "string"]),
            close_date: superstruct.struct.union(["null", "string"]),
            close_cause: superstruct.struct.union(["null", superstruct.struct.literal("1"), superstruct.struct.literal("11"), superstruct.struct.literal("21"), superstruct.struct.literal("31")]),
            successor_corporate_number: superstruct.struct.union(["null", "string"]),
            change_cause: "string",
            assignment_date: "string",
            en_name: "string",
            en_prefecture_name: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
            en_address_line: superstruct.struct.union(["null", "string"]),
            en_address_outside: superstruct.struct.union(["null", "string"]),
            furigana: "string",
            hihyoji: "string"
        }
    });
    return validator(jsonObj);
}
function validate_NTACorporateInfoSearcherResponse_v20230901(jsonObj) {
    var struct = superstruct.superstruct({ types: {} });
    var validator = struct({
        version: "string",
        data: superstruct.struct.array([{
                published_date: superstruct.struct.optional(superstruct.struct.union(["undefined", "string"])),
                sequence_number: "string",
                corporate_number: "string",
                process: superstruct.struct.union([superstruct.struct.literal("1"), superstruct.struct.literal("11"), superstruct.struct.literal("12"), superstruct.struct.literal("13"), superstruct.struct.literal("21"), superstruct.struct.literal("22"), superstruct.struct.literal("71"), superstruct.struct.literal("72"), superstruct.struct.literal("81"), superstruct.struct.literal("99")]),
                correct: "string",
                update_date: "string",
                change_date: "string",
                name: "string",
                name_image_id: superstruct.struct.union(["null", "string"]),
                kind: superstruct.struct.union([superstruct.struct.literal("101"), superstruct.struct.literal("201"), superstruct.struct.literal("301"), superstruct.struct.literal("302"), superstruct.struct.literal("303"), superstruct.struct.literal("304"), superstruct.struct.literal("305"), superstruct.struct.literal("399"), superstruct.struct.literal("401"), superstruct.struct.literal("499")]),
                prefecture_name: superstruct.struct.union(["null", "string"]),
                city_name: superstruct.struct.union(["null", "string"]),
                street_number: "string",
                town: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
                kyoto_street: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
                block_lot_num: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
                building: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
                floor_room: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
                address_image_id: superstruct.struct.union(["null", "string"]),
                jisx0402: superstruct.struct.union(["null", "string"]),
                post_code: superstruct.struct.union(["null", "string"]),
                address_outside: "string",
                address_outside_image_id: superstruct.struct.union(["null", "string"]),
                close_date: superstruct.struct.union(["null", "string"]),
                close_cause: superstruct.struct.union(["null", superstruct.struct.literal("1"), superstruct.struct.literal("11"), superstruct.struct.literal("21"), superstruct.struct.literal("31")]),
                successor_corporate_number: superstruct.struct.union(["null", "string"]),
                change_cause: "string",
                assignment_date: "string",
                en_name: "string",
                en_prefecture_name: superstruct.struct.optional(superstruct.struct.union(["undefined", "null", "string"])),
                en_address_line: superstruct.struct.union(["null", "string"]),
                en_address_outside: superstruct.struct.union(["null", "string"]),
                furigana: "string",
                hihyoji: "string"
            }]),
        query: "string",
        count: "number",
        offset: "number",
        limit: "number",
        facets: superstruct.struct.union(["null", {
                area: superstruct.struct.optional(superstruct.struct.union(["undefined", superstruct.struct.tuple(["string", "number"])])),
                kind: superstruct.struct.optional(superstruct.struct.union(["undefined", superstruct.struct.tuple(["string", "number"])])),
                process: superstruct.struct.optional(superstruct.struct.union(["undefined", superstruct.struct.tuple(["string", "number"])])),
                close_cause: superstruct.struct.optional(superstruct.struct.union(["undefined", superstruct.struct.tuple(["string", "number"])]))
            }])
    });
    return validator(jsonObj);
}
function validate_AddressResolverResponse_v20240101(jsonObj) {
    var struct = superstruct.superstruct({ types: {} });
    var validator = struct({
        version: "string",
        data: superstruct.struct.array([{
                jisx0402: "string",
                old_code: "string",
                postal_code: "string",
                prefecture: "string",
                prefecture_kana: "string",
                prefecture_roman: "string",
                city: "string",
                city_kana: "string",
                city_roman: "string",
                county: "string",
                county_kana: "string",
                county_roman: "string",
                city_without_county_and_ward: "string",
                city_without_county_and_ward_kana: "string",
                city_without_county_and_ward_roman: "string",
                city_ward: "string",
                city_ward_kana: "string",
                city_ward_roman: "string",
                town: "string",
                town_kana: "string",
                town_roman: "string",
                town_raw: "string",
                town_kana_raw: "string",
                koaza: "string",
                kyoto_street: superstruct.struct.union(["null", "string"]),
                building: "string",
                floor: "string",
                town_partial: "boolean",
                town_addressed_koaza: "boolean",
                town_multi: "boolean",
                town_chome: "boolean",
                town_jukyohyoji: "boolean",
                update_status: superstruct.struct.union([superstruct.struct.literal(0), superstruct.struct.literal(1), superstruct.struct.literal(2)]),
                update_reason: superstruct.struct.union([superstruct.struct.literal(0), superstruct.struct.literal(1), superstruct.struct.literal(2), superstruct.struct.literal(3), superstruct.struct.literal(4), superstruct.struct.literal(5), superstruct.struct.literal(6)]),
                corporation: superstruct.struct.union(["null", {
                        name: "string",
                        name_kana: "string",
                        block_lot: "string",
                        block_lot_num: superstruct.struct.union(["null", "string"]),
                        post_office: "string",
                        code_type: "number"
                    }])
            }])
    });
    return validator(jsonObj);
}
function validate_CityResolverResponse_v20240101(jsonObj) {
    var struct = superstruct.superstruct({ types: {} });
    var validator = struct({
        version: "string",
        data: superstruct.struct.array([{
                jisx0402: "string",
                prefecture_code: "string",
                prefecture: "string",
                prefecture_kana: "string",
                prefecture_roman: "string",
                city_code: "string",
                city: "string",
                city_kana: "string",
                city_roman: "string",
                county: "string",
                county_kana: "string",
                county_roman: "string",
                city_without_county_and_ward: "string",
                city_without_county_and_ward_kana: "string",
                city_without_county_and_ward_roman: "string"
            }])
    });
    return validator(jsonObj);
}
function validate_AddressSearcherResponse_v20240101(jsonObj) {
    var struct = superstruct.superstruct({ types: {} });
    var validator = struct({
        query: {
            q: superstruct.struct.union(["null", "string"]),
            t: superstruct.struct.union(["null", "string"]),
            prefecture: superstruct.struct.union(["null", "string"]),
            county: superstruct.struct.union(["null", "string"]),
            city: superstruct.struct.union(["null", "string"]),
            city_ward: superstruct.struct.union(["null", "string"]),
            town: superstruct.struct.union(["null", "string"]),
            kyoto_street: superstruct.struct.union(["null", "string"]),
            block_lot_num: superstruct.struct.union(["null", "string"]),
            building: superstruct.struct.union(["null", "string"]),
            floor_room: superstruct.struct.union(["null", "string"])
        },
        count: "number",
        offset: "number",
        limit: "number",
        facets: superstruct.struct.union(["null", superstruct.struct.array([superstruct.struct.tuple(["string", "number"])])]),
        version: "string",
        data: superstruct.struct.array([{
                jisx0402: "string",
                old_code: "string",
                postal_code: "string",
                prefecture: "string",
                prefecture_kana: "string",
                prefecture_roman: "string",
                city: "string",
                city_kana: "string",
                city_roman: "string",
                county: "string",
                county_kana: "string",
                county_roman: "string",
                city_without_county_and_ward: "string",
                city_without_county_and_ward_kana: "string",
                city_without_county_and_ward_roman: "string",
                city_ward: "string",
                city_ward_kana: "string",
                city_ward_roman: "string",
                town: "string",
                town_kana: "string",
                town_roman: "string",
                town_raw: "string",
                town_kana_raw: "string",
                koaza: "string",
                kyoto_street: superstruct.struct.union(["null", "string"]),
                building: "string",
                floor: "string",
                town_partial: "boolean",
                town_addressed_koaza: "boolean",
                town_multi: "boolean",
                town_chome: "boolean",
                town_jukyohyoji: "boolean",
                update_status: superstruct.struct.union([superstruct.struct.literal(0), superstruct.struct.literal(1), superstruct.struct.literal(2)]),
                update_reason: superstruct.struct.union([superstruct.struct.literal(0), superstruct.struct.literal(1), superstruct.struct.literal(2), superstruct.struct.literal(3), superstruct.struct.literal(4), superstruct.struct.literal(5), superstruct.struct.literal(6)]),
                corporation: superstruct.struct.union(["null", {
                        name: "string",
                        name_kana: "string",
                        block_lot: "string",
                        block_lot_num: superstruct.struct.union(["null", "string"]),
                        post_office: "string",
                        code_type: "number"
                    }])
            }])
    });
    return validator(jsonObj);
}
